import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3148AffiliationActionHandler } from "./U3148AffiliationActionHandlers";
import type { U3148LogicalUnit } from "../../../../U3148Service";

// Typage des props du composant
interface U3148AffiliationActionDeleteDlgProps {
  u3148AffiliationActionHandler: U3148AffiliationActionHandler;
  t: TFunction;
  NS: string;
}

function U3148AffiliationActionDeleteDlg({ u3148AffiliationActionHandler, t, NS }: U3148AffiliationActionDeleteDlgProps) {
  if (!u3148AffiliationActionHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u3148AffiliationActionHandler.isDeleteDialogOpen} onClose={u3148AffiliationActionHandler.onDlgDeleteClose} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t("user.msgDeleteUserAction", {
          count: u3148AffiliationActionHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u3148AffiliationActionHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => {
          const lu = row as unknown as U3148LogicalUnit;
          return (
            <span key={lu.logicalUnitCode} className="inline-block text-gray-800">
              {`${lu.logicalUnitCode} - ${lu.logicalUnitDescription}`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3148AffiliationActionDeleteDlg;
